import { Component, OnInit } from "@angular/core";
import { FormControl, UntypedFormBuilder } from "@angular/forms";
import {
  StringCustomFieldConfig,
  DataService,
  SharedModule,
  FormInputComponent,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import {
  switchMap,
  catchError,
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { Observable, of, Subject, concat, tap, take } from "rxjs";
import {
  DefaultProductDescriptionsDocument,
  DefaultProductDescriptionsQuery,
  SortOrder,
} from "src/generated-gql/graphql";

export type AddDescResult = {
  defaultProductDescriptionId: string | undefined;
};

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./select.component.html",
})
export class DescSelectComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit
{
  resolveWith: (result?: AddDescResult) => void;
  constructor(
    private dataService: DataService,
  ) {}

  isListInput?: boolean = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: StringCustomFieldConfig;
  descriptions$: Observable<DefaultProductDescriptionsQuery["defaultProductDescriptions"]["items"]>;
  input$ = new Subject<string>();
  isLoading = false;
  selectedArtist: any;
  ngOnInit(): void {
    this.dataService
      .query(DefaultProductDescriptionsDocument, {
        options: {
          filter: {
            isDefault: {
              eq: true,
            },
          },
        },
      })
      .single$.subscribe(({ defaultProductDescriptions }) => {
        if (defaultProductDescriptions.items && !this.formControl.value) {
          this.formControl.patchValue(defaultProductDescriptions.items[0]);
        }
      });

    this.descriptions$ = concat(
      this.dataService
        .query(DefaultProductDescriptionsDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .single$.pipe(
          switchMap(data => {
            return of(data.defaultProductDescriptions.items);
          })
        ),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap(term =>
          this.dataService
            .query(DefaultProductDescriptionsDocument, {
              options: {
                filter:
                  term && term.length > 0
                    ? {
                        name: {
                          contains: term,
                        },
                      }
                    : undefined,
                take: 10,
                sort: {
                  createdAt: SortOrder.Desc,
                },
              },
            })
            .mapStream(({ defaultProductDescriptions }) => defaultProductDescriptions.items)
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => (this.isLoading = false))
            )
        )
      )
    );
  }
  compareFn(item1: { id: string } | null, item2: { id: string } | null) {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  trackByFn(item: { id: any }) {
    return item.id;
  }
}
